// @flow

export const MODEL = 'Fertilizer'
export const TREE = 'fertilizersData'
export const BRANCH = 'fertilizers'
export const OPERATIONS_TREE = 'fertilizersModule'
export const OPERATIONS_BRANCH = 'operations'

// Api End Point
export const URL = 'zonecalc/fertilizer/'

// Model Properties
export const PROP_ID = 'id'
export const PROP_FERTILIZER_ID = PROP_ID
export const PROP_SEASON = 'season'
export const PROP_NAME = 'name'
export const PROP_PRICE = 'price'
export const PROP_N = 'n'
export const PROP_P = 'p'
export const PROP_K = 'k'
export const PROP_S = 's'
export const PROP_MG = 'mg'
export const PROP_MN = 'mn'
export const PROP_ZN = 'zn'
export const PROP_CA = 'ca'
export const PROP_FE = 'fe'
export const PROP_CU = 'cu'
export const PROP_B = 'b'
export const PROP_LIME = 'lime'
export const PROP_PRIMARY_NUTRIENTS = 'primaryNutrients'
export const PROP_HEFTY_PRIMARY_NUTRIENTS = 'heftyPrimaryNutrients'
export const PROP_LIMEEQUIVALENT = 'limeEquivalent'
export const PROP_STATE = 'state'
export const PROP_USGALLONSPERMT = 'usGallonsPerMT'
export const PROP_CUSTOM = 'custom'
export const PROP_COMMERCIALPRODUCT = 'commercialProduct'
export const PROP_RX_NAME = 'rx_name'
export const PROP_TARGET_N = 'target_n'
export const PROP_TARGET_P = 'target_p'
export const PROP_TARGET_K = 'target_k'
export const PROP_TARGET_S = 'target_s'
export const PROP_ASSET = 'asset'
export const PROP_DEFAULT = 'default'

export const SOLID = 'Solid'
export const LIQUID = 'Liquid'
